import { render, staticRenderFns } from "./BillingTop.vue?vue&type=template&id=780671a7"
import script from "./BillingTop.vue?vue&type=script&lang=js"
export * from "./BillingTop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports